<template>
  <profile-component/>
</template>

<script>
import ProfileComponent from '@/spa/components/profile/ProfileComponent';

export default {
  name: 'ProfilePage',

  components: {
    ProfileComponent,
  },
};

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/spa/pages/ProfilePage.vue